import { render, staticRenderFns } from "./invited-customer.vue?vue&type=template&id=496693d8&"
import script from "./invited-customer.vue?vue&type=script&lang=js&"
export * from "./invited-customer.vue?vue&type=script&lang=js&"
import style0 from "./invited-customer.vue?vue&type=style&index=0&module=true&lang=less&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports